<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="compliance-donut-loading"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
  
        <card-header :title="$t('widget_compliance_by_status')"></card-header>
        <vs-row>
          <vs-col>
            <div class="body-card-widget">
              <vue-apex-charts
                class="mt-6 mb-8"
                type="donut"
                height="325"
                :options="chartOptions"
                :series="series"
              />
            </div>
          </vs-col>
        </vs-row>
  
    </vs-card>
  </div>
</template>

<script>
import ComplianceDonutConfig from './ComplianceDonutConfig.js'
import VueApexCharts from 'vue-apexcharts'
//requests
import dashboard from '@/http/requests/compliance'
//mixins
import loading from '@/mixins/Loading.js'
import CardHeader from './CardHeader.vue'
export default {
  mixins: [loading],
  components: {
    VueApexCharts,
    CardHeader
  },
  computed: {
    isLoading() {
      return this.loading.compliance_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('compliance-donut-loading')
      } else {
        this.closeLoading('compliance-donut-loading')
      }
    },
  },
  data() {
    return {
      chartOptions: ComplianceDonutConfig,
      series: [1],
      labelsDonut: [],
      colors: [],
      permitList: [],
      loading: {
        compliance_donut: false,
      },
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading.compliance_donut = true
      dashboard
        .complianceTableList()
        .then((res) => {
          this.permitList = res.data.compliance
          this.fillChartData(this.permitList)
          this.loading.compliance_donut = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.compliance_donut = false
        })
    },
    fillChartData(dataToChart) {
      const dataValues = []
      const states = []
      dataToChart.forEach((element) => {
        if (states.indexOf(element.status_name) === -1) {
          states[states.length] = element.status_name
          this.colors[this.colors.length] = element.status_color
        }
      })
      states.forEach((element) => {
        dataValues[dataValues.length] = this.countByState(dataToChart, element)
      })
      this.series = dataValues
      this.labelsDonut = states
      ApexCharts.exec(
        'donut-compliance',
        'updateOptions',
        {
          series: dataValues,
          fill: {
            colors: this.colors,
          },
          legend: {
            markers: {
              fillColors: this.colors,
            },
          },
          labels: this.labelsDonut,
        },
        false,
        true
      )
    },
    countByState(data, state) {
      let count = 0
      data.forEach((element) => {
        if (element.status_name === state) {
          count++
        }
      })
      return count
    },
  },
}
</script>